import Page from "../../components/page";
import {getAppBase} from "../../../util/env";
import {PageProps} from "../../components/page/page-view";
import {FormattedMessage, useIntl} from "react-intl";
import "./logout.scss";
export interface LogoutProps extends Omit<PageProps, "children"> {}
function Logout(props: LogoutProps) {
  const intl = useIntl();
  return <Page
      className={"Logout"}
      meta={{
        title: intl.formatMessage({
          defaultMessage: "Logout completed",
          description: "window meta title for the logout page",
        }),
        description: intl.formatMessage({
          defaultMessage: "Logout completed successfully",
          description: "window meta description for the logout page",
        }),
      }}
  >
    <header>
      <h1>
        <FormattedMessage
            defaultMessage="Logout completed"
            description="Heading for the logout screen"
        />
      </h1>
    </header>
    <div>
      <p>
        <FormattedMessage
            defaultMessage="You've been logged out successfully. In case you're using a public or shared computer, you may want to clear your browser history and cache before closing the browser."
            description={"logout info message"}
        />
      </p>
      <a href={window.location.href.split(getAppBase())[0] + getAppBase()}>
        <FormattedMessage
            defaultMessage="Continue"
            description={"continue button label"}
        />
      </a>
    </div>
  </Page>;
}
export default Logout;
